import { COLORS, FONTS } from '@app/src/ui';
import styled from 'styled-components';
import { Checkbox } from '@app/src/common/Checkbox';

const ROOT = 'MyAccount/listAvailable/AnnouncementCard';

interface Props {
  color?: string;
  isDisabled?: boolean;
}

export const Wrapper = styled.article`
  border: 1px solid ${COLORS.GRAY};
  border-radius: 6px;
  width: 300px;
  min-height: 188px;
  padding: 19px 16px 20px 50px;
  position: relative;
  font-family: ${FONTS.ROBOTO};
  font-size: 16px;
  line-height: 22px;
  color: ${COLORS.BLACK};
`;

Wrapper.displayName = `${ROOT}/Wrapper`;

export const CheckboxWrapper = styled(Checkbox)`
  position: absolute;
  top: 19px;
  left: 16px;
`;

CheckboxWrapper.displayName = `${ROOT}/CheckboxWrapper`;

export const ButtonAction = styled.span`
  position: absolute;
  top: 6px;
  right: 8px;
  display: flex;
`;

ButtonAction.displayName = `${ROOT}/ButtonAction`;

export const Content = styled.div``;

Content.displayName = `${ROOT}/Content`;

export const Category = styled.span`
  display: inline-block;
  font-size: 14px;
  color: ${(props: Props) => props.color && `${props.color}`};
`;

Category.displayName = `${ROOT}/Category`;

export const HighLights = styled.h3`
  font-size: 16px;
  color: ${COLORS.BLACK_BOLD};
  margin-top: 12px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

HighLights.displayName = `${ROOT}/HighLights`;

export const PublicationDate = styled.p`
  font-size: 15px;
  color: ${COLORS.GRAY_TEXT};
  margin-top: 9px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

PublicationDate.displayName = `${ROOT}/PublicationDate`;

export const Description = styled.p`
  margin-top: 8px;
  display: -webkit-box;
  max-width: 200px;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

Description.displayName = `${ROOT}/Description`;

export const Subtitle = styled.span`
  display: inline-block;
  font-weight: 700;
`;

Subtitle.displayName = `${ROOT}/Subtitle`;

export const LoaderWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  svg{
    fill: transparent;
    stroke-width: 5px;
    stroke: #b7b0b0;
    stroke-dasharray: 100%;
    animation: rotate .5s linear infinite;
  }
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`;

LoaderWrapper.displayName = `${ROOT}/LoaderWrapper`;

export const IconWrapper = styled.span`
  background: #f0f0f0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  cursor: pointer;

  svg {
    pointer-events: none;
  }

  ${(props: Props) => props.isDisabled && `
    opacity: .5;
    cursor: not-allowed
  `}
`;

IconWrapper.displayName = `${ROOT}/IconWrapper`;